import { useChips } from "@website/ui/chips/chips.hook";
import styles from "@website/ui/chips/chips.module.scss";
import { ChipsPropertiesType } from "@website/ui/chips/chips.types";
import { LazyImage } from "@website/ui/lazy-image";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const Component: FC<ChipsPropertiesType> = (properties) => {
  const {
    disabled,
    EndIcon,
    StartIcon,
    selected,
    variant,
    color,
    text,
    avatar,
    alt,
    className,
    transparent,
    textStyle,
    tooltip,
    textClassName,
    datatestid
  } = properties;
  const { endIconProperties, rootProperties } = useChips(properties);

  return (
    <div
      {...rootProperties}
      className={`${styles["chips"]} ${styles[variant || "contained"]} ${
        styles[color || "primary"]
      } ${disabled ? styles["disabled"] : ""} ${
        selected ? styles["selected"] : ""
      } ${className}`}
      style={
        color?.startsWith("#")
          ? {
              color: transparent ? color : "white",
              backgroundColor: transparent ? `${color}20` : color
            }
          : {}
      }
      title={tooltip}
      data-testid={datatestid}
    >
      {avatar ? (
        <LazyImage alt={alt} className={styles["image"]} src={avatar} />
      ) : StartIcon ? (
        <div className={styles["start-icon"]}>{StartIcon}</div>
      ) : null}
      <div className={`${textClassName} ${styles["text"]} ${textStyle}`}>
        {text}
      </div>
      {EndIcon ? (
        <div {...endIconProperties} className={styles["end-icon"]}>
          {EndIcon}
        </div>
      ) : null}
      <div className={styles["overlay"]} />
    </div>
  );
};

export const Chips = memo(Component, deepCompare);
